import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-stone-200 shadow-lg animate-fade-in-up"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1 pr-4">
            <p className="text-sm text-hr-text-secondary">
              We use cookies to improve your experience, analyze site traffic, and support marketing efforts. By continuing to browse, you agree to our use of cookies.{' '}
              <Link to="/cookie-policy" className="text-hr-purple hover:underline font-medium">
                Cookie Policy
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={declineCookies}
              className="text-hr-text-secondary border-stone-300 hover:bg-stone-50"
              data-testid="cookie-decline-btn"
            >
              Decline
            </Button>
            <Button
              size="sm"
              onClick={acceptCookies}
              className="bg-hr-purple hover:bg-hr-purple-dark text-white"
              data-testid="cookie-accept-btn"
            >
              Accept Cookies
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
